// @flow

import * as React from 'react';

import { webhosting, type ProductPayload } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { UnorderedList, TypoListItem } from '@gandi/ui';

type Props = {
  baseStorage: ProductPayload['shopping']?.['baseStorage'],
  additionalStorage: ProductPayload['shopping']?.['additionalStorage'],
  addedStorage: number,
};

export function PaasAddDiskDetails({
  baseStorage,
  additionalStorage,
  addedStorage,
}: Props): React.MixedElement {
  const translator = useTranslator();
  const { __ } = translator;

  const NA = __('N/A');

  const actualStorageDetails = __(
    'The current disk size is %(acutalStorage)s',
    {
      acutalStorage:
        Number.isFinite(baseStorage) && Number.isFinite(additionalStorage)
          ? webhosting.getStorageTranslation({
              // $FlowFixMe[unsafe-addition] values are testing though isFinite()
              storage: baseStorage + additionalStorage,
              translator,
            })
          : NA,
    },
  );

  const addedStorageDetail = __('You are buying an extra %(addedStorage)s', {
    addedStorage: webhosting.getStorageTranslation({
      storage: addedStorage,
      translator,
    }),
  });

  const total =
    Number.isFinite(baseStorage) && Number.isFinite(additionalStorage)
      ? // $FlowFixMe[unsafe-addition] values are tested by above isFinite();
        baseStorage + additionalStorage + addedStorage
      : undefined;

  const totalStorageDetail = __('The new disk size will be %(totalStorage)s', {
    totalStorage: Number.isFinite(total)
      ? webhosting.getStorageTranslation({
          // $FlowFixMe[incompatible-call] total is tested by above isFinite();
          storage: total,
          translator,
        })
      : NA,
  });

  return (
    <UnorderedList>
      <TypoListItem>{actualStorageDetails}</TypoListItem>
      <TypoListItem>{addedStorageDetail}</TypoListItem>
      <TypoListItem>{totalStorageDetail}</TypoListItem>
    </UnorderedList>
  );
}
